<template>
  <ul v-if="selectedCampus" class="menu__list">
    <li
      v-for="(menu_item, index) in getCategory()"
      :key="index"
      :class="{ active: menu_item.show }"
      class="menu__list-item"
    >
      <div
        v-if="
          typeof menu_item.hasPermission === 'function'
            ? menu_item.hasPermission()
            : true
        "
        @click="menu_item.show = !menu_item.show"
        class="menu__list-link"
      >
        {{ menu_item.name }}
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 6L8 10L12 6"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <!--        <span-->
        <!--          v-if="menu_item && menu_item.danger"-->
        <!--          class="sidebar-menu__counter sidebar-menu__counter&#45;&#45;red"-->
        <!--        >{{ menu_item.danger }}</span>-->
        <!--        <span-->
        <!--          v-if="menu_item && menu_item.warning"-->
        <!--          class="sidebar-menu__counter sidebar-menu__counter&#45;&#45;yellow"-->
        <!--        >{{ menu_item.warning }}</span>-->
      </div>
      <div v-if="menu_item.show">
        <ul
          v-if="
            menu_item &&
            menu_item.items &&
            menu_item.items.length > 0 &&
            typeof menu_item.hasPermission === 'function'
              ? menu_item.hasPermission()
              : true
          "
          class="menu__list-submenu"
        >
          <template v-for="(child, index) in menu_item.items">
            <li
              v-if="
                typeof child.hasPermission === 'function'
                  ? child.hasPermission()
                  : true
              "
              :key="index"
            >
              <router-link
                :class="{ active: $route.path === child.url }"
                exact-active-class="active"
                active-class="active"
                :to="child.url"
                @click="openPage(child.url)"
              >
                {{ child.name }}
                <span
                  v-if="child && child.danger"
                  class="sidebar-menu__counter sidebar-menu__counter--red"
                >
                  {{ child.danger }}
                </span>
                <span
                  v-if="child && child.warning"
                  class="sidebar-menu__counter sidebar-menu__counter--yellow"
                >
                  {{ child.warning }}
                </span>
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'TheSidebar',
  data() {
    return {
      // showSidebar: false,
      showBlock: true,
      active: undefined,
      menu: [
        {
          route_path: 'student-list',
          name: 'תלמידים',
          active: 'students',
          show: false,
          hasPermission: () =>
            this.$perm('student.list', this.selectedCampus.id) ||
            this.$perm('student.show', this.selectedCampus.id),
          subcategories: [
            {
              name: 'מועמדים לקליטה',
              url: '',
              show: false,
              danger: 0,
              warning: 0,
              hasPermission: () =>
                this.$perm('menu.applicants', this.selectedCampus.id),
              items: [
                {
                  name: 'רשימת מועמדים',
                  url: '/new-student-list',
                  danger: 0,
                  warning: 0
                }
              ]
            },
            {
              name: 'תלמידים וחניכים',
              url: '',
              show: false,
              danger: 0,
              warning: 0,
              hasPermission: () =>
                this.$perm('menu.students', this.selectedCampus.id),
              items: [
                {
                  name: 'רשימת תלמידים',
                  url: '/student-list',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm('student.list', this.selectedCampus.id) ||
                    this.$perm('student.show', this.selectedCampus.id)
                },
                // {
                //     name: 'ציונים',
                //     url: '',
                //     danger: 0,
                //     warning: 0,
                // },
                // {
                //     name: 'צווי בית משפט',
                //     url: '',
                //     danger: 0,
                //     warning: 0,
                // },
                {
                  name: 'הערכות חניך',
                  url: '/assessment-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_student_assessment',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'חוות דעת',
                  url: '/feedback-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_feedbacks',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'תוכנית אישית',
                  url: '/plan-blank-tables',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_personal_conversations',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'דוח ביצוע צוות גרעיני',
                  url: '/nuclear-stuff-blank-tables',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_personal_conversations',
                      this.selectedCampus.id
                    )
                },
                // {
                //   name: 'צוות גרעיני',
                //   url: '/new-blank-1',
                //   danger: 0,
                //   warning: 0,
                //   hasPermission: () =>
                //     this.$perm('student.list', this.selectedCampus.id)
                // },

                {
                  name: 'וועדות ופיקוחים',
                  url: '/commission-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_commission',
                      this.selectedCampus.id
                    )
                },

                {
                  name: 'שיחות אישיות',
                  url: '/personal-conversation-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_personal_conversations',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'ליווי הורים',
                  url: '/parent-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm('student.view_parents', this.selectedCampus.id)
                },
                // {
                //     name: 'טיפול רפואי',
                //     url: '',
                //     danger: 0,
                //     warning: 0,
                // },
                // {
                //     name: 'תהליכים טיפוליים',
                //     url: '',
                //     danger: 0,
                //     warning: 0,
                // },
                {
                  name: 'אישורי חניכים',
                  url: '/students-security',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm('student.view_parents', this.selectedCampus.id)
                },
                {
                  name: 'אירועים חריגים',
                  url: '/incident-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_incidents',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'דוח ביקור רופא',
                  url: '/doctor-visit-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_doctor_blank',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'שיחות עם תלמידים',
                  url: '/coordinators-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_student_talk_blank',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'דוח צוות טיפולי',
                  url: '/team-report-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_team_report_blank',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'קשר עם הורים',
                  url: '/contact-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_contact_blank',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'דוח אחות',
                  url: '/nursevisit-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_nurse_blank',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'אירועים חריגים',
                  url: '/incidentshort-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_incident_blank',
                      this.selectedCampus.id
                    )
                },
                {
                  name: 'דוח לימודי התנהגותי',
                  url: '/education-blanks',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm(
                      'student.view_behavior_education_and_behavior_blank',
                      this.selectedCampus.id
                    )
                },

                {
                  name: 'נוכחות חניכים',
                  url: '/reports',
                  danger: 0,
                  warning: 0,
                  hasPermission: () =>
                    this.$perm('report.list', this.selectedCampus.id) ||
                    this.$perm('report.show', this.selectedCampus.id)
                }
                // {
                //     name: 'אישורי יציאה',
                //     url: '',
                //     danger: 0,
                //     warning: 0,
                // },
              ]
            },
            {
              name: 'בוגרים',
              url: '',
              danger: 0,
              warning: 0,
              show: false,
              hasPermission: () =>
                this.$perm('menu.graduates', this.selectedCampus.id),
              items: [
                {
                  name: 'רשימת בוגרים',
                  url: '/graduated-student-list',
                  danger: 0,
                  warning: 0
                }
              ]
            },
            {
              name: 'עוזבי המסגרת',
              url: '',
              danger: 0,
              warning: 0,
              show: false,
              hasPermission: () =>
                this.$perm('menu.expelled_students', this.selectedCampus.id),
              items: [
                {
                  name: 'רשימת עוזבי המסגרת',
                  url: '/kicked-student-list',
                  danger: 0,
                  warning: 0
                }
              ]
            },
            {
              name: 'חניכים שנמחקו',
              url: '',
              danger: 0,
              warning: 0,
              show: false,
              hasPermission: () =>
                this.$perm('menu.removed_students', this.selectedCampus.id),
              items: [
                {
                  name: 'רשימת חניכים שנמחקו',
                  url: '/deleted-student-list',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        },
        {
          route_path: 'workers-list',
          name: 'עובדים',
          active: 'workers',
          show: false,
          hasPermission: () =>
            this.$perm('worker_list.show', this.selectedCampus.id),
          subcategories: [
            {
              name: 'רשימת עובדים',
              url: '',
              show: false,
              danger: 0,
              warning: 0,
              items: [
                {
                  name: 'רשימת עובדים',
                  url: '/workers-list',
                  danger: 0,
                  warning: 0
                },
                {
                  name: 'עובדים שנמחקו',
                  url: '/workers-delete-list',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        },
        {
          route_path: '',
          name: 'פנימיה',
          active: 'boarding-school',
          show: false,
          subcategories: []
        },
        {
          route_path: '',
          name: 'מרכז מוזיקה',
          active: 'music-school',
          show: false,
          subcategories: []
        },
        {
          route_path: '',
          name: 'חוגים',
          active: 'sections',
          show: false,
          subcategories: []
        },
        {
          route_path: 'service-orders',
          name: 'הגדרות',
          active: 'maintenance',
          show: false,
          hasPermission: () =>
            this.$perm('service_orders.list', this.selectedCampus.id) ||
            this.$perm('service_orders.show', this.selectedCampus.id) ||
            this.$perm('service_orders.create', this.selectedCampus.id),
          subcategories: [
            {
              name: 'רשימת קריאות',
              url: '',
              show: false,
              danger: 0,
              warning: 0,
              items: [
                {
                  name: 'רשימת קריאות',
                  url: '/service-orders',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        },
        {
          route_path: '/centers/:slug/day',
          name: 'מרכז למידה',
          active: 'study-center',
          show: true,
          hasPermission: () =>
            this.$perm('service_orders.list', this.selectedCampus.id) ||
            this.$perm('service_orders.show', this.selectedCampus.id) ||
            this.$perm('service_orders.create', this.selectedCampus.id),
          subcategories: [
            {
              name: 'מרכז למידה',
              url: '',
              show: true,
              danger: 0,
              warning: 0,
              items: [
                {
                  name: 'עריכת תבנית',
                  url: 'template',
                  danger: 0,
                  warning: 0
                },
                // {
                //   name: 'חודש',
                //   url: 'month',
                //   danger: 0,
                //   warning: 0
                // },
                // {
                //   name: 'שבוע',
                //   url: 'week',
                //   danger: 0,
                //   warning: 0
                // },
                {
                  name: 'יום',
                  url: 'day',
                  danger: 0,
                  warning: 0
                }
              ]
            },
            {
              name: 'דו״ח מורים',
              url: '',
              show: true,
              danger: 0,
              warning: 0,
              items: [
                {
                  name: 'דו״ח מורים',
                  url: 'reports',
                  danger: 0,
                  warning: 0
                },
                {
                  name: 'דו״חות',
                  url: 'reports',
                  danger: 0,
                  warning: 0
                }
              ]
            },
            {
              name: 'נוכחות',
              url: '',
              show: true,
              danger: 0,
              warning: 0,
              items: [
                {
                  name: 'נוכחות חניכים',
                  url: 'students-report',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        },
        {
          route_path: '/security/entry  ',
          name: 'ביטחון',
          active: 'security',
          show: false,
          hasPermission: () =>
            this.$perm('security.can_view', this.selectedCampus.id),
          subcategories: [
            {
              name: 'אבטחה',
              url: '',
              show: true,
              danger: 0,
              warning: 0,
              hasPermission: () =>
                this.$perm('security.can_view', this.selectedCampus.id),
              items: [
                {
                  name: 'מסך מאבטח',
                  url: '/security/entry',
                  danger: 0,
                  warning: 0
                },
                {
                  name: 'בקרת כניסה',
                  url: '/scan-select',
                  danger: 0,
                  warning: 0
                }
                // {
                //   name: 'controllers',
                //   url: '/controllers',
                //   danger: 0,
                //   warning: 0
                // }
              ]
            }
          ]
        },
        {
          route_path: '',
          name: 'הסעות',
          active: 'transport',
          show: false,
          subcategories: []
        },
        {
          active: 'settings',
          subcategories: [
            {
              name: 'כללי',
              url: '#',
              show: true,
              danger: 0,
              warning: 0,
              hasPermission: () =>
                this.$perm('settings.view', this.selectedCampus.id),
              items: [
                {
                  name: 'תפקידים',
                  url: '/settings-departments',
                  danger: 0,
                  warning: 0
                },
                {
                  name: 'הגדרות',
                  url: '/settings',
                  danger: 0,
                  warning: 0
                },
                {
                  name: 'ניהול רשימות מידע',
                  url: '/settings-management-list',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        },
        {
          active: 'own_permits',
          subcategories: [
            {
              name: 'מבקרים',
              url: '',
              show: true,
              danger: 0,
              warning: 0,
              hasPermission: () =>
                this.$perm('security.can_view', this.selectedCampus.id),
              items: [
                {
                  name: 'אישורי כניסה',
                  url: '/own-permission',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        },
        {
          route_path: 'projects',
          name: 'תוכניות',
          active: 'projects',
          show: false,
          hasPermission: () =>
            this.$perm('worker_list.show', this.selectedCampus.id),
          subcategories: [
            {
              name: 'תוכניות',
              url: '/projects',
              show: false,
              danger: 0,
              warning: 0,
              items: [
                // {
                //   name: 'מחלקות',
                //   url: '/student-list',
                //   danger: 0,
                //   warning: 0
                // },
                {
                  name: 'תוכניות',
                  url: '/projects',
                  danger: 0,
                  warning: 0
                },
                {
                  name: 'קבוצות',
                  url: '/projects-groups',
                  danger: 0,
                  warning: 0
                },
                {
                  name: 'מערכת שעות',
                  url: '/schedule-of-all-projects',
                  danger: 0,
                  warning: 0
                },

                {
                  name: 'ניהול דיווחים',
                  url: '/report-of-all-projects',
                  danger: 0,
                  warning: 0
                },
                {
                  name: 'לוח בקרה',
                  url: '/dashboard-of-all-projects',
                  danger: 0,
                  warning: 0
                }
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {
    ...mapState({
      selectedCampus: s => s.settings.selectedCampus
    }),
    ...mapGetters({
      user: 'auth/user',
      settings: 'settings/getSettings',
      menuPart: 'front/getMenuPart'
    }),
    showSidebar() {
      return this.$store.getters['front/getSidebarStatus'];
    },
    part() {
      return this.menuPart ? this.menuPart : false;
    }
  },
  watch: {
    '$route.fullPath'() {
      this.findActiveMenu();
      this.setMenuPart(this.$route.meta.part);
    }
  },
  methods: {
    ...mapActions({
      setMenuPart: 'front/setMenuPart',
      setSidebarStatus: 'front/setSidebarStatus',
      signOut: 'auth/signOut'
    }),
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    async logout() {
      await this.signOut();
    },
    hideSidebar() {
      this.setSidebarStatus(!this.showSidebar);
    },
    getCategory() {
      const category = this.menu.filter(item => {
        return item.active === this.part;
      });
      return category && category[0] ? category[0].subcategories : [];
    },
    openPage(path, hideSidebar) {
      if (window.innerWidth < 992) {
        this.hideSidebar();
      }
      this.$router.push({ path });
    },
    findActiveMenu() {
      this.menu.forEach(menu => {
        menu.subcategories.forEach(subcategory => {
          if (_.isArray(subcategory.items)) {
            subcategory.items.forEach(item => {
              if (this.$route.path === item.url) {
                subcategory.show = true;
                menu.show = true;
                this.active = menu.active;
              }
            });
          }
        });
      });
    }
  }
};
</script>

<style lang="scss">
.router-link-exact-active {
  text-decoration: none;

  &.mobile-menu__row {
    .btn--blue.disabled {
      background: linear-gradient(270deg, #409fff 32.55%, #3078bf 100%);
      color: #fff;
    }
  }

  .mobile-menu__back-btn.disabled svg {
    stroke: #fff !important;
  }
}
</style>
